import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { VerificationStatusEnum } from 'src/app/pages/identity-verification/enums/verification-status.enum';
import { UtilityService } from 'src/app/shared/services/utility.service';
import { environment } from 'src/environments/environment';
import { IdVerification } from './models/id-verification.model';

@Component({
  selector: 'app-identity-verification-modal',
  templateUrl: './identity-verification-modal.component.html',
  styleUrls: ['./identity-verification-modal.component.scss'],
})
export class IdentityVerificationModalComponent implements OnChanges {
  // User's current identity verification status. This determines the modal's content and behaviour.
  @Input() verificationStatus: VerificationStatusEnum;

  private cachedVerificationData: IdVerification | null = null;

  constructor(
    private modalCtrl: ModalController,
    private utilityService: UtilityService,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['verificationStatus']) {
      // Reset cached data when verificationStatus changes
      this.cachedVerificationData = null;
    }
  }

  /**
   * for close the modal popup
   */
  closeModal(): void {
    this.modalCtrl.dismiss();
  }

  openIdentityVerificationWeb(): void {
    this.utilityService.openExternalLink(`${environment.webAppUrl()}/identity-verification/select-document-type`);
  }

  handleVerificationAction(): void {
    if (!this.verificationStatus || this.verificationStatus === 'IN_PROGRESS') {
      this.openIdentityVerificationWeb();
    } else {
      this.closeModal();
    }
  }

  get idVerification(): IdVerification {
    // Return cached data if available
    if (!this.cachedVerificationData) {
      this.cachedVerificationData = this.getVerificationData();
    }
    return this.cachedVerificationData;
  }

  private getVerificationData(): IdVerification {
    const isActionRequired = !this.verificationStatus || this.verificationStatus === VerificationStatusEnum.IN_PROGRESS;

    if (isActionRequired) {
      return {
        ctaActions: {
          ctaText: 'Verify Identity',
          ctaType: 'button',
          ctaAction: 'click',
        },
        heading: 'Before you can contact support workers, we need to verify your identity',
        subheading:
          "Verifying your identity is essential to maintaining a safe and trusted community on Mable, by ensuring everyone is who they claim to be. Use your driver licence, passport, or Medicare card to verify your identity <strong>instantly.</strong><br><br> If you require any help, please call us on <a href='tel:+611300736573'>1300&nbsp;736&nbsp;573</a> Monday through Friday, 9am to 6pm AEST (Sydney).",
      };
    }

    // For PENDING or LOCKED_OUT states
    return {
      ctaActions: {
        ctaText: 'Ok, got it',
        ctaType: 'button',
        ctaAction: 'click',
      },
      heading: 'Before you can contact support workers, we need to verify your identity',
      subheading:
        "Some of your details don't match the Australian government records. Please call us on <a href='tel:+611300736573'>1300 736 573</a> Monday through Friday, 9am to 6pm AEST (Sydney), and one of our friendly support specialists can help verify your identity. They'll be able to take a closer look and guide you through the next steps.",
    };
  }
}
